import React from 'react';
import { useTranslation } from 'react-i18next';
import {connect} from "react-redux";
import Avatar from "../../../../../../../../components/avatar";
import Icon from "../../../../../../../../components/icon";
import {contactContent} from "../../../../../../../../../actions/contactDetailsActions";
import './index.css';

function ContactSharedWith (props) {

    const { t } = useTranslation();
    const {
        profile,
        setContactContent
    } = props;

    const handleClick = () => {
        setContactContent('sharing-settings');
    };

    if(profile){
        return (
            <div className="shared-with d-flex align-items-center justify-content-end ml-2 w-50">
                <p className="mr-2 mb-0 text-nowrap">{t("textSharedWith")}</p>
                <Avatar onClick={handleClick} className="flex-shrink-0" size={'2.5em'} src={profile.pictureUrl}/>
            </div>
        )
    } else {
        return <Icon animated={'pulse'} name="spinner"/>
    }

}

const mapStateToProps = (state) => {
    return {
        profile: state.profileReducer.getProfile
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setContactContent: (string) =>  {
            dispatch(contactContent(string))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactSharedWith);
